/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import addToHomeScreen from "views/articles/AddToHomeScreen"
import Link from "next/link"
import shareButtonPhoto from "views/articles/AddToHomeScreen/share-button.jpg"
import addToHomeScreenPhoto from "views/articles/AddToHomeScreen/add-to-home-screen-button-ar.jpg"
import addButtonPhoto from "views/articles/AddToHomeScreen/add-button-ar.jpg"
import homeScreenPhoto from "views/articles/AddToHomeScreen/home-screen.jpg"
import { event } from "utils/gtag"
import InstallAppollowVideo from "./InstallAppollowVideo"

const AddAppollowToYourHomeScreenAR = () => {
  const article = addToHomeScreen["ar"]
  return (
    <InstantArticle {...article}>
      <div dir="rtl" style={{ textAlign: "justify" }}>
        <p>
          تم تصميم Appollow باستخدام تقنية تطبيقات الويب التقدمية (PWAs) وهي نوع
          من تطبيقات الويب التي تقدم تجربة شبيهة بالتطبيق الأصلي لـ المستخدمين.
          يمكن تثبيتها على الشاشة الرئيسية للجهاز و تم استعماله تمامًا مثل تطبيق
          عادي ، دون الحاجة إلى تحميل اي شيئ من متجر التطبيقات.
        </p>
        <h2> فوائد تثبيت Appollow على الشاشة الرئيسية: </h2>
        <ul>
          <li>
            <b>أداء محسّن:</b> تم تصميم Appollow ليكون سريعًا وفعالاً ، مع
            التركيز على تقديم تجربة مستخدم سلسة. عن طريق التثبيت Appollow على
            الشاشة الرئيسية ، يمكنك الاستمتاع بفوائد التطبيق ، مثل التحميل
            الأسرع ووضع عدم توفر الاتصال بالإنترنت.
          </li>
          <li>
            <b>وصول أسهل:</b> يتيح لك تثبيت Appollow على الشاشة الرئيسية القيام
            بذلك الوصول إلى التطبيق بنقرة واحدة فقط، دون الحاجة إلى فتح المتصفح
            والبحث عن التطبيق. يمكن أن يكون هذا مفيدًا بشكل خاص إذا كنت تريد
            استخدام التطبيق بشكل متكرر.
          </li>
          <li>
            <b> محتوى محدث:</b> يمكن تحديث Appollow تلقائيًا وفائقًا بسرعة، حتى
            يتمكن المستخدمون دائمًا من الوصول إلى أحدث الميزات و المحتوى. هذا
            على عكس التطبيقات الأصلية، التي تتطلب من المستخدمين قم بتحديثها
            يدويًا من متجر التطبيقات.
          </li>
        </ul>
        <h2> كيفية تثبيت Appollow على شاشتك الرئيسية باستخدام Safari: </h2>
        <ol>
          <li>
            افتح Safari وانتقل إلى
            <Link href="https://www.appollow.net"> Appollow </Link>
          </li>
          <li>
            اضغط على زر المشاركة (المربع الذي يشير السهم للخارج منه) في الجزء
            السفلي من الشاشة.
          </li>
          <div className="text-center">
            <img
              src={shareButtonPhoto.src}
              alt="share button"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
          <li>قم بالتمرير لأسفل واضغط على إضافة إلى الشاشة الرئيسية.</li>
          <div className="text-center">
            <img
              src={addToHomeScreenPhoto.src}
              alt="add to home screen"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
          <li>ستظهر مطالبة تطلب منك تأكيد التثبيت. اضغط إضافة للاستمرار.</li>
          <div className="text-center">
            <img
              src={addButtonPhoto.src}
              alt="add button"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
          <li>
            ستتم إضافة Appollow إلى الشاشة الرئيسية لجهازك ويمكن استعماله مثل اي
            تطبيق عادي.
          </li>

          <div className="text-center">
            <img
              src={homeScreenPhoto.src}
              alt="home screen"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
        </ol>
        <InstallAppollowVideo />
        <p>
          استمتع باستخدام التطبيق مباشرة من شاشتك الرئيسية مع تحسين الأداء
          وسهولة الوصول والمحتوى المحدث. دعنا نعرف إذا كنت لديك أي اقتراحات
          للميزات التي ترغب في رؤيتها في الإصدارات المستقبلية من Appollow عن
          طريق الاتصال بنا من خلال صفحة <Link href="/contact"> اتصل بنا</Link>.
        </p>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenAR
